import PropTypes from 'prop-types';
import React, { useState } from 'react';
import classNames from 'classnames';
import Icon from '../Icon';
import styles from './PageNavigation.module.scss';

const PageNavigation = ({ items = [], activePage = {
        title: '',
        id: 0,
    } }) => {
    const [isMobileExpanded, setIsMobileExpanded] = useState(false);

    return (
        <div className={classNames(styles['PageNavigation'], {
            [styles['PageNavigation--Expanded']]: isMobileExpanded,
        })}>
            <button
                className={styles['PageNavigation__Button']}
                onClick={() => setIsMobileExpanded(!isMobileExpanded)}
            >
                <span>
                    <span className={styles['PageNavigation__ButtonTag']}>Menu</span>
                    <span className={styles['PageNavigation__ButtonText']}>{activePage.title}</span>
                </span>
                <span className={styles['PageNavigation__Icon']}>
                    <Icon type={'chevron'} size={'large'} />
                </span>
            </button>
            <nav className={styles['PageNavigation__Navigation']}>
                <ol className={styles['PageNavigation__List']}>
                    {items.map((item, index) => (
                        <li
                            key={index}
                            className={classNames(styles['PageNavigation__Item'], {
                                [styles['PageNavigation__Item--Expandable']]: item.items && item.items.length,
                            })}
                        >
                            <a
                                href={item.href}
                                className={
                                    classNames(styles['PageNavigation__Link'], {
                                        [styles['PageNavigation__Link--Active']]: item.id === activePage.id,
                                    })}
                            >
                                {item.title}

                                <div className={styles['PageNavigation__Chevron']}>
                                    <Icon type={'chevronThin'} size={'large'} />
                                </div>
                            </a>
                        </li>
                    ))}
                </ol>
            </nav>
        </div>
    )
};

PageNavigation.propTypes = {
    items: PropTypes.array,
    activePage: PropTypes.object,
};

export default PageNavigation;
